"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTopLevelStatus = void 0;
exports.OrderTopLevelStatus = {
    Received: "received",
    CollectingSample: "collecting_sample",
    SampleWithLab: "sample_with_lab",
    Completed: "completed",
    Cancelled: "cancelled",
    Failed: "failed",
};
